var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0104C0 5.83196 5.81927 0 12.9977 0C20.1761 0 25.9954 5.83196 25.9954 13.0104C25.9954 20.1888 20.1761 26.0208 12.9977 26.0208C5.81927 26.0208 0 20.1888 0 13.0104Z",
    fill: "#0000FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.29 16.4258L14.7054 13.0104L11.29 9.59501",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/ChevronRightIcon.421e18f0c5520a5499779ffe7da4326a.svg";
export { ForwardRef as ReactComponent };